var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader?presets[]=es2015&cacheDirectory=true&sourceMap=true!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./RoHeaderBurger.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?{\"id\":\"data-v-624ea870\"}!./RoHeaderBurger.html"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/ro-header/RoHeaderBurger.vue
// module id = 329
// module chunks = 1